import React from "react";
import { AiFillMediumCircle } from "react-icons/ai";


const Social = () => {
  return (
    <div className="home_social">
      <a
        href="https://github.com/Ruthvikbr"
        className="home_social_icon"
        target="_blank"
      >
        <i className="uil uil-github"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/ruthvikbr/"
        className="home_social_icon"
        target="_blank"
      >
        <i className="uil uil-linkedin"></i>
      </a>
      <a
        href="https://twitter.com/RuthvikBR"
        className="home_social_icon"
        target="_blank"
      >
        <i className="uil uil-twitter"></i>
      </a>
      <div className="home_social">
      <a
        href="https://medium.com/@Ruthvik_B.R"
        className="home_social_icon"
        target="_blank"
        rel="noreferrer"
      >
        <AiFillMediumCircle size={24} />
      </a>
    </div>
    </div>
  );
};

export default Social;
